import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/scss/main.scss'
import UserRegister from '@/assets/images/user_registred.jpeg'
import WearHouseIn from '@/assets/images/wearhouse_in.jpeg'
import UserIn from '@/assets/images/mongolia.png'
import * as VueGoogleMaps from 'vue2-google-maps'
import '@fortawesome/fontawesome-free/css/all.css'
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(ElementUI, { locale })
// Vue.use(ElementUI)
Vue.config.productionTip = false

// VueGoogleMaps бүртгэх
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD5yAPe69smGeq05VGdixR_gdMmpHpH2n8', // Google Maps API Key оруулна
    libraries: ['places'] // шаардлагатай сангуудыг нэмнэ
  }
})

// Валют форматлах filter
Vue.filter('formatCurrency', function (value) {
  return new Intl.NumberFormat().format(value) + '₮'
})

// App эхлүүлэх
new Vue({
  router,
  store,
  data: {
    trackCodeDetailDialog: false,
    trackCodeAddDialog: false,
    loginDialog: false,
    registerDialog: false,
    fullscreenLoading: false,
    orderDetailDialog: false,
    addressAddDialog: false,
    resetPasswordDialog: false,
    statusArray: [
      {
        id: 1,
        value: 100,
        label: ' Хэрэглэгч бүртгэсэн',
        img_url: UserRegister
      },
      {
        id: 2,
        value: 110,
        label: ' Эрээн дах агуулах хүлээн авсан',
        img_url: WearHouseIn
      },
      {
        id: 3,
        value: 120,
        label: 'Монгол дах салбар хүлээн авсан',
        img_url: UserIn
      },
      {
        id: 4,
        value: 130,
        label: ' Хэрэглэгч хүргэлтээр авна',
        img_url: UserIn
      },
      {
        id: 5,
        value: 140,
        label: ' Хэрэглэгч салбараас очиж авна',
        img_url: UserIn
      },
      {
        id: 6,
        value: 150,
        label: ' Хэрэглэгч салбар дээр хадгалуулна',
        img_url: UserIn
      },
      {
        id: 7,
        value: 160,
        label: ' Хүргэлтийн ажилтанд хуваарилсан',
        img_url: UserIn
      },
      {
        id: 8,
        value: 170,
        label: ' Ачаа салбар дээр үлдсэн',
        img_url: UserIn
      },
      {
        id: 9,
        value: 180,
        label: ' Трак код шалгуулах',
        img_url: UserIn
      },
      {
        id: 10,
        value: 190,
        label: ' Цуцалсан',
        img_url: UserIn
      },
      {
        id: 11,
        value: 200,
        label: ' Хэрэглэгч хүлээн авсан',
        img_url: UserIn
      }
    ],
    checkTrackCodeStatus: [
      {
        id: 1,
        value: 'new',
        label: ' Үүсгэсэн',
        type: 'success'
      },
      {
        id: 2,
        value: 'to_ereen',
        label: 'Эрээн салбарт шилжүүлсэн',
        type: 'success'
      },
      {
        id: 3,
        value: 'cancel',
        label: 'Цуцалсан',
        type: 'success'
      },
      {
        id: 4,
        value: 'to_mongol',
        label: 'Монгол салбарт шилжүүлсэн',
        type: 'success'
      },
      {
        id: 5,
        value: 'to_user',
        label: 'Хэрэглэгч рүү шилжүүлсэн',
        type: 'success'
      },
      {
        id: 6,
        value: 'from_user',
        label: 'Хэрэглэгч хариу илгээсэн',
        type: 'success'
      }
    ],
    checkTrackCode: false
  },
  render: h => h(App)
}).$mount('#app')
